import Button from "./common/Button";
import Image from "./common/Image";
import DOMPurify from "dompurify";

function Teaser(props) {
  let classNames = `${props.className ?? ""}`;
  //if (props.color) classNames += "lg:tw-bg-white lg:tw-bg-" + props.color;
  let single = false;

  let innerClassNames = `${
    props.index % 2 ? "md:odd:tw-flex-row-reverse" : ""
  } tw-px-2 tw-py-5 tw-mt-5 tw-mb-10 tw-max-w-screen-lg tw-m-auto lg:tw-mb-3`;
  let third = (props.index + 1) % 3 === 0;
  if (!props.isThird) {
    if (third) {
      innerClassNames += " md:tw-hidden";
    }
    innerClassNames +=
      " lg:tw-flex lg:tw-p-0 lg:tw-rounded-2xl lg:tw-bg-gray-light";
  } else {
    single = true;
    innerClassNames =
      "md:tw-flex md:tw-p-0 lg:tw-rounded-2xl md:tw-bg-gray-light sm:tw-hidden lg:tw-hidden";
    innerClassNames +=
      " md:tw-flex md:tw-p-0 md:tw-rounded-2xl md:tw-bg-gray-light";
  }

  return (
    <div className={classNames}>
      <div className={innerClassNames + (single ? "" : "")}>
        <div
          className={
            single
              ? "tw-m-3 tw-mt-0 md:tw-w-2/4 md:tw-m-0 md:tw-p-8 md:tw-pr-0 md:tw-pl-5"
              : "tw-m-3 tw-mt-0 lg:tw-w-2/4 lg:tw-m-0 lg:tw-p-5"
          }
        >
          <Image
            className={
              single
                ? " md:tw-h-full tw-w-full tw-object-cover tw-rounded-2xl"
                : "md:tw-h-48 lg:tw-h-full tw-w-full tw-object-cover tw-rounded-2xl"
            }
            src={props.image}
            width={960}
            height={576}
          />
        </div>
        <div
          className={
            single
              ? "tw-m-3 tw-mt-6 md:tw-w-2/4 md:tw-m-0 md:tw-p-12 md:tw-pr-4"
              : "tw-m-3 tw-mt-6 lg:tw-w-2/4 lg:tw-m-0 lg:tw-p-12"
          }
        >
          <h2
            className={
              single
                ? "tw-text-2xl md:tw-text-3xl tw-font-italic tw-font-normal tw-uppercase tw-tracking-tight"
                : "tw-text-2xl lg:tw-text-3xl tw-font-italic tw-font-normal tw-uppercase tw-tracking-tight"
            }
          >
            {props.title}
          </h2>
          {props.text && (
            <div className="tw-mt-2">
              <p
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(props.text),
                }}
              ></p>
              <p className="tw-clear-both"></p>
            </div>
          )}
          {props.button.label && (
            <Button
              color="teal"
              className="tw-w-full md:tw-w-auto tw-mt-6 md:tw-px-8"
              href={props.button.href}
              title={props.button.label}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Teaser;
